import { Link } from "@/i18n/navigation";
import { isPortalPath } from "@/lib/portalRoutes";
import NextLink from "next/link";
import { ComponentProps } from "react";

type LinkProps = ComponentProps<typeof Link> & {
  title: string;
};

const MainLink = ({ ...props }: LinkProps) => {
  const className = `bg-primary border-primary lg:hover:bg-background lg:hover:text-primary flex min-h-11 items-center justify-center rounded-none border-2 px-6 py-2.5 text-center text-sm leading-snug font-bold text-white shadow-xs transition-[background-color,border-color,color,box-shadow] duration-300 *:h-5 ${props.className ?? ""}`;

  // Portal routes live outside `[locale]`; next-intl's Link would prefix them
  // with the active locale and send the customer to a 404 (ticket #887).
  if (typeof props.href === "string" && isPortalPath(props.href)) {
    return (
      <NextLink href={props.href} className={className}>
        {props.title}
      </NextLink>
    );
  }

  return (
    <Link href={props.href} className={className}>
      {props.title}
    </Link>
  );
};

export default MainLink;
